import { CelebrationCheckbox } from "@components/adapters/celebration/Checkbox";
import type { CheckboxProps } from "@components/contracts/Checkbox.types";

export const Checkbox: React.FC<CheckboxProps> = (props) => (
  <CelebrationCheckbox {...props} />
);

export type { CheckboxProps };
